import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { EFeatureToggles } from '../configurations/common';
import { ConfigurationFacade } from '../facades/configuration.facade';
import { combineLatest } from 'rxjs';
import { AuthorizationFacade } from '../facades/authorization.facade';

export const guestCartAuthGuard: CanActivateFn = () => {
  const router: Router = inject(Router);
  const configurationFacade: ConfigurationFacade = inject(ConfigurationFacade);
  const authorizationFacade: AuthorizationFacade = inject(AuthorizationFacade);

  return combineLatest([
    configurationFacade.isFeatureEnabled(EFeatureToggles.EXTERNAL_QUOTE_CHECKOUT),
    authorizationFacade.isAuthenticated$
  ]).pipe(
    map(([isFeatureEnabled, isAuthenticated]: [boolean, boolean]) => {
      if (isFeatureEnabled) {
        return true;
      }
      if (!isAuthenticated) {
        router.navigate(['/']);
        return false;
      }
      return true;
    })
  );
};
